import React from "react";
import SuperAdminDashboard from "./SuperAdminDashboard";

const SuperAdminPanel: React.FC = () => {
  return <SuperAdminDashboard />;
};

export default SuperAdminPanel;
